import { useRoutes } from 'react-router-dom';
import { routes } from 'client/views/navigation/routes/routes';
import { Page } from '@oliasoft-open-source/react-ui-library';
import { Companies } from 'client/views/navigation/companies/companies';
import { Explore } from 'client/views/explore/explore';
import { CompanyData } from 'client/views/company-data/company-data';
import { Query } from 'client/views/query/query';
import { TaskManager } from 'client/views/task-manager/task-manager';
import { UserSettings } from 'client/views/user-settings/user-settings';
import { SharedObjectViewer } from 'client/views/objects/shared-objects';
import { MainContainer } from 'client/components/main/main';
import { Analytics } from 'client/views/analytics/analytics';
import TestSentry from 'client/views/sentry/test-sentry';
import { FeatureFlags } from '@oliasoft/feature-flags';

const emptyPage = (
  <Page>
    No content
  </Page>
);

export const AppContent = () => useRoutes([
  {
    index: true,
    element: <Companies />,
  },
  {
    path: routes.root.pattern.path,
    element: <MainContainer />,
    children: [
      {
        path: routes.explore.pattern.path,
        element: <Explore />,
      },
      {
        path: routes.companyData.pattern.path,
        element: <CompanyData />,
      },
      {
        path: routes.query.pattern.path,
        element: <Query />,
      },
      {
        path: routes.taskManager.pattern.path,
        element: <TaskManager />,
      },
      {
        path: routes.analytics.pattern.path,
        element: <Analytics />,
      },
      {
        path: routes.accessManagement.pattern.path,
        element: emptyPage,
      },
      {
        path: routes.userSettings.pattern.path,
        element: <UserSettings />,
      },
      {
        path: routes.userSettingsTabs.pattern.path,
        element: <UserSettings />,
      },
      ...(FeatureFlags.isActive('Sentry test page')
        ? [
            {
              path: routes.sentryTest.pattern.path,
              element: <TestSentry />,
            },
          ]
        : []),
    ],
  },
  {
    path: routes.sharedObjects.pattern.path,
    element: <SharedObjectViewer />,
  },
]);